import React, { Component } from 'react';
import {
  Grid,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  CircularProgress,
  IconButton,
  AppBar,
  Button,
  Tabs,
  Tab,
  Box,
  Collapse,
} from '@material-ui/core';
import moment from 'moment';
//import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import ExportToExcel from '../../components/ExportToExcel.jsx'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import TabPanel from '../../components/TabPanel';
// import { enqueueSnackbar } from 'notistack';
// import { useSnackbar } from 'notistack';
import { fetchAllOneTimePayments } from '../../services/api/admin';
// import SubPatientsList from '../SubPatientsList';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';
import './style.css';

class PaymentsList extends Component {
  state = {
    isLoading: false,
    getPaymentsInfo: [],
    patients: {},
    pageIndex: 0,
    pageLimit: 20,
    tabPosition: 0,
    practiceId: null,
    restrictedProviderInfo: [],
    providerInfo: {},
    expanded: false,
    paymentId: '',
    paymentId: '',
    provider: [],
    disableButton: false,
  };

  async componentDidMount() {
    try {
      await this.fetchPaymentsInfo();
    } catch (err) {
      console.log(err);
    } finally {
      this.setState({ isLoading: false });
    }
  }

  handleTabPositionChange = async (event, newTabPosition) => {
    this.setState({
      tabPosition: newTabPosition,
      pageIndex: 0,
      pageLimit: 20,
      expanded: false,
    });
    this.fetchPaymentsInfo();
  };

  handleExpand = result => {
    const { paymentId } = this.state;
    if (result.id === paymentId) {
      this.setState({
        expanded: false,
        paymentId: '',
      });
    } else {
      this.setState({
        expanded: true,
        paymentId: result.id,
      });
    }
  };

  fetchPaymentsInfo = async () => {
    const { enqueueSnackbar } = this.props;
    const { pageLimit, pageIndex } = this.state;
    try {
      const getPaymentsInfo = await fetchAllOneTimePayments(
        pageIndex * 20,
        pageLimit
      );
      this.setState({ getPaymentsInfo: getPaymentsInfo.data }, () => {});
    } catch (err) {
      enqueueSnackbar('Unable to fetch payments Info, please try again.');
    }
  };

  onPageForward = async () => {
    const { pageIndex } = this.state;
    this.setState({ pageIndex: pageIndex + 1 }, () => {
      this.fetchPaymentsInfo();
    });
  };

  onPageBack = async () => {
    const { enqueueSnackbar } = this.props;
    const { pageIndex } = this.state;
    if (pageIndex === 0) {
      enqueueSnackbar('You are on the first page');
    } else {
      this.setState({ pageIndex: pageIndex - 1 }, () => {
        this.fetchPaymentsInfo();
      });
    }
  };

  render() {
    const { classes } = this.props;
    const {
      tabPosition,
      pageIndex,
      pageLimit,
      getPaymentsInfo,
      isLoading,
    } = this.state;
    return isLoading ? (
      <div className={classes.loading}>
        <CircularProgress />
      </div>
    ) : (
      <div className={classes.root}>
        <div className="expBtn">
        <ExportToExcel tableId="table-to-xls" filename="reports" />
          {/* <ReactHTMLTableToExcel
            id="test-table-xls-button"
            className="exportBtn btn submit-btn"
            table="table-to-xls"
            filename="reports"
            sheet="reports"
            buttonText="Export"
          /> */}
        </div>
        <AppBar
          position="static"
          color="default"
          classes={{ root: classes.appBar }}
        >
          <Tabs value={tabPosition} onChange={this.handleTabPositionChange}>
            <Tab label="SALIVA Plan Payment" />
          </Tabs>
        </AppBar>
        <TabPanel>
          {isLoading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            <Grid item xs={12} style={{padding: '0px'}}>
              <div style={{overflow:"scroll"}}>
              <Table id="table-to-xls">
                <TableHead>
                  <TableRow className="liMainTab">
                    <TableCell>FirstName</TableCell>
                    <TableCell>LastName</TableCell>
                    <TableCell>DOB</TableCell>
                    <TableCell>Phone No</TableCell>
                    <TableCell>Customer Email</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Amount Paid</TableCell>
                    <TableCell />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getPaymentsInfo.map(result => (
                    <>
                      <TableRow key={result.id} className="nameLitit">
                        <TableCell width="250">
                          {result && result.firstName}
                        </TableCell>
                        <TableCell width="250">
                          {result && result.lastName}
                        </TableCell>
                        <TableCell width="250">
                          {result &&
                            moment.utc(result.birthdate).format('MM/DD/YYYY')}
                        </TableCell>
                        <TableCell width="250">
                          {result && result.phoneForSms}
                        </TableCell>
                        <TableCell width="250">
                          {/* <Grid container alignItems="center"> */}
                            {/* <Grid item xs={12} xl={3} />
                            <Grid item xs={12} xl={3}> */}
                              {result && result.customerEmail}
                            {/* </Grid>
                          </Grid> */}
                        </TableCell>
                        <TableCell width="250">
                          {result && result.paymentStatus}
                        </TableCell>
                        <TableCell width="250">
                          {result && (result.amountTotal / 100).toFixed(2)}
                        </TableCell>
                        {/* <TableCell /> */}
                        {/* {tabPosition === 0 ? (
                            <IconButton
                              aria-label="expand row"
                              size="small"
                              onClick={() => this.handleExpand(result)}
                            >
                              {this.state.expanded &&
                              this.state.paymentId &&
                              result.id === this.state.paymentId ? (
                                <KeyboardArrowUpIcon />
                              ) : (
                                <KeyboardArrowDownIcon />
                              )}
                            </IconButton>
                          ) : null} */}
                        {/* </TableCell> */}
                      </TableRow>
                      {/* {tabPosition === 0 &&
                      this.state.expanded &&
                      this.state.paymentId &&
                      result.id === this.state.paymentId ? ( */}
                      <TableRow>
                        {/* <SubPatientsList
                            paymentId={this.state.paymentId}
                            open={this.state.expanded}
                          /> */}

                        <TableCell
                          style={{ paddingBottom: 0, paddingTop: 0 }}
                          colSpan={6}
                        >
                          <Box margin={1}>
                            <Typography
                              variant="h6"
                              gutterBottom
                              component="div"
                            >
                              Name List
                            </Typography>

                            <Table
                              size="small"
                              aria-label="purchases"
                              className="nameLiTab"
                            >
                              <TableHead>
                                {result && result.subPatient.length > 0 ? (
                                  <TableRow>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Birth Date</TableCell>
                                    <TableCell>Test Date</TableCell>
                                    <TableCell>Type</TableCell>
                                  </TableRow>
                                ) : null}
                              </TableHead>
                              <TableBody>
                                {result && result.subPatient.length > 0
                                  ? result.subPatient.map(patient => (
                                      <TableRow
                                        key={patient.id}
                                        className="nameLiRow"
                                      >
                                        <TableCell component="th" scope="row">
                                          {patient && patient.patientName}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                          {patient &&
                                            moment.utc(patient.birthDate).format(
                                              'MM/DD/YYYY'
                                            )}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                          {patient &&
                                            moment.utc(patient.testDate).format(
                                              'MM/DD/YYYY'
                                            )}
                                        </TableCell>
                                        <TableCell component="th" scope="row">
                                          {patient && patient.testType}
                                        </TableCell>
                                      </TableRow>
                                    ))
                                  : null}
                              </TableBody>
                            </Table>
                          </Box>
                        </TableCell>
                      </TableRow>
                      {/* ) : null} */}
                    </>
                  ))}
                </TableBody>
              </Table>
              </div>

              <div className={classes.pageTurners}>
                <IconButton disabled={pageIndex === 0}>
                  <ArrowBackIosIcon
                    style={{ opacity: pageIndex === 0 ? '0.5' : '1.0' }}
                    color="primary"
                    variant="contained"
                    onClick={this.onPageBack}
                  />
                </IconButton>
                <IconButton
                  disabled={
                    getPaymentsInfo && getPaymentsInfo.length < pageLimit
                  }
                >
                  <ArrowForwardIosIcon
                    style={{
                      opacity:
                        getPaymentsInfo.length < pageLimit ? '0.5' : '1.0',
                    }}
                    color="primary"
                    variant="contained"
                    onClick={this.onPageForward}
                  />
                </IconButton>
              </div>
            </Grid>
          )}
        </TabPanel>
      </div>
    );
  }
}

const styles = () => ({
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  root: {
    padding: '3em',
  },
  list: {
    paddingBottom: '2em',
  },
  actions: {
    textAlign: 'right',
  },
  button: {
    marginLeft: '20px',
  },
  mergeButton: {
    marginLeft: '20px',
    color: 'black',
    backgroundColor: '#FFF6BF',
    '&:hover': {
      marginLeft: '20px',
      color: 'black',
      backgroundColor: '#cdc48d',
    },
  },
  pageTurners: {
    width: '100%',
    marginTop: '5px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  container: {
    padding: '3em',
  },
  appBar: {
    zIndex: 10,
  },
  header: {
    paddingBottom: '3em',
  },
  selectInput: {
    marginTop: '0.5em',
    marginBottom: '1em',
  },
  headerText: {
    fontWeight: 'normal',
    fontSize: '1.8em',
    lineHeight: '19px',
    color: '#1C1C1C',
    paddingBottom: '0.5em',
  },
  helpText: {
    paddingBottom: '0.5em',
  },
  marginLeftAuto: {
    marginLeft: 'auto',
  },
  marginLeftTen: {
    marginLeft: 6,
  },
});

export default withSnackbar(withStyles(styles)(PaymentsList));
